import {createReducer} from "./utils/createReducer"
import { UtilsAction } from "../action/utilsAction"
import { mapSlugToName, buildMapProductType } from "src/shared/utils/helpers"
import { IProductType, IProduct } from "src/type/product"

interface IUtilsState {
  mapCategories: any;
  mapProductType: any;
  productTypes: IProductType[] | undefined;
  cotationProductSelected: IProduct | undefined;
}

const defaultState: IUtilsState = {
  mapCategories: undefined,
  mapProductType: undefined,
  productTypes: undefined,
  cotationProductSelected: undefined,
};

const initMapNameCategories = {
  request: (state, action) => ({
    ...state
  }),
  success: (state, action) => {
    return {
      ...state,
      mapCategories: mapSlugToName(action.data)
    }
  },
  failure: (state, action) => ({
    ...state
  })
}

const initMapProductType = {
  request: (state, action) => ({
    ...state
  }),
  success: (state, action) => {
    return {
      ...state,
      categoriesOriginal: action.data,
      mapProductType: action.data && action.data.length > 0 ? buildMapProductType(action.data) : undefined,
      productTypes: action.data,
    }
  },
  failure: (state, action) => ({
    ...state
  })
}

const updateCotationProductSelected = (state, action) => {
  return {
    ...state,
    cotationProductSelected: action.product
  }
}

export const utilsReducer = createReducer<IUtilsState>(defaultState, {
  [UtilsAction.INIT_MAP_CATEGORIES_REQUEST]: initMapNameCategories.request,
  [UtilsAction.INIT_MAP_CATEGORIES_SUCCESS]: initMapNameCategories.success,
  [UtilsAction.INIT_MAP_CATEGORIES_FAILURE]: initMapNameCategories.failure,
  [UtilsAction.INIT_MAP_PRODUCT_TYPE_REQUEST]: initMapProductType.request,
  [UtilsAction.INIT_MAP_PRODUCT_TYPE_SUCCESS]: initMapProductType.success,
  [UtilsAction.INIT_MAP_PRODUCT_TYPE_FAILURE]: initMapProductType.failure,
  [UtilsAction.UPDATE_COTATION_PRODUCT_SELECTED]: updateCotationProductSelected,
});



// WEBPACK FOOTER //
// ./src/core/redux/reducer/utilsReducer.ts